module.exports = __webpack_public_path__ + "static/media/gs.49fa4d63.svg";